import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64d3361c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UserCenter" }
const _hoisted_2 = { style: {"display":"flex","margin-bottom":"16px"} }
const _hoisted_3 = { class: "UserCenter-userInfo" }
const _hoisted_4 = { class: "UserCenter-userWallet" }
const _hoisted_5 = { class: "UserCenter-userAbnormal" }
const _hoisted_6 = { style: {"display":"flex","margin-bottom":"16px"} }
const _hoisted_7 = { class: "UserCenter-userOrder" }
const _hoisted_8 = { class: "UserCenter-userGoods" }
const _hoisted_9 = { style: {"display":"flex","gap":"16px"} }
const _hoisted_10 = { style: {"width":"63.7%","height":"122px"} }
const _hoisted_11 = { style: {"width":"35%","height":"122px"} }
const _hoisted_12 = { class: "line" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-guanbibeifen1" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

import { reactive, onMounted, computed, watch, ref, Ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { isD2C, isJA } from '@/store'
import { useRequest } from '@/util/useLoading'
import UserInfo from './modules/UserInfo.vue'
import UserWallet from './modules/UserWallet.vue'
import UserOrder from './modules/UserOrder.vue'
import UserAbnormal from './modules/UserAbnormal.vue'
import CommonFunctions from './modules/CommonFunctions.vue'
import ActivitySection from './modules/ActivitySection.vue'
import UserStores from './modules/UserStores.vue'
import UserGoods from './modules/UserGoods.vue'
import FavoriteProducts from './modules/FavoriteProducts.vue'
import Guide from '@/components/guide/index.vue'
import ObligationModal from './components/ObligationDialog.vue'
import AdditionStockWarning from './components/AdditionStockWarning.vue'
import ReturnMoneyTip from './components/ReturnMoneyTip.vue'
import { Site, UseType } from '@/common/const'
import CommonTip from '@/components/CommonTip/index.vue'
import BillNotify from './modules/BillNotify.vue'
import PackageRetentionDialog from './components/PackageRetentionDialog.vue'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { CustomerOverviewRespDTO, CustomerShopRespDTO, DeliveryAbnormalOrderCount } from '@/apis/interface/customer'
import { getOverviewWorkbenchInfoApi, workbenchOrderCoountApi } from '@/apis/usercenter'
import { TaEvent, taTrack } from '@/util/buryingPoint'

interface DataDTO {
  userData?: CustomerShopRespDTO
  viewWidth?: number
  shopList?: any[]
}

enum Z_INDEX_LIST {
  AdditionStockWarning = 3006,
  ObligationModal = 3002
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const isSub = store.getters.isSub
const user = computed(() => store.getters.user)
/** 当前店铺 */
const curShop = store.getters.curShop
/** 有待付款订单提示 */
const obligationVisible = ref(false)
/** 是否显示Line */
const showLine = ref(true)
/** 概览信息： 账户余额、商品管理 */
const overviewInfo: Ref<CustomerOverviewRespDTO> = ref({})
/** 工作台：订单、异常数量 */
const workbenchOrderInfo: Ref<DeliveryAbnormalOrderCount> = ref({})

const data: DataDTO = reactive({
  /** 用户信息 */
  userData: undefined,
  viewWidth: 0,
  shopList: []
})
const [getLineValue, setLineValue] = useUserConfig(ENUM_CONFIG_CODE.LINE_MODAL)

watch(
  store.state.observe,
  () => {
    data.viewWidth = document.documentElement.clientWidth
  },
  { immediate: true }
)

onMounted(async () => {
  if (store.getters.isLogin) {
    const val = await getLineValue()
    showLine.value = val !== '1'
  }
  getOverviewInfo()
  getWorkbanchOrderInfo()

  taTrack({
    event: TaEvent.PAGE_VIEW,
    value: {
      position: 'workbench'
    }
  })
})

/** 获取工作台：订单、异常数量 */
const getWorkbanchOrderInfo = async () => {
  const res = await workbenchOrderCoountApi({})
  workbenchOrderInfo.value = res.data as DeliveryAbnormalOrderCount
}

// 获取账户概览信息
/** 工作台： 账户余额、商品管理 */
const [loading2, getOverviewInfo] = useRequest(async () => {
  const formData = {
    accountType: user.value?.accountType,
    customerId: user.value?.customerShopList.find(
      (e: any) => e.customerShopId === curShop
    ).customerId,
    customerShopId: curShop,
    mainCustomerId: user.value?.mainCustomerId,
    systemSource: isD2C() ? UseType.d2c : UseType.b2b
  }
  const res = await getOverviewWorkbenchInfoApi(formData)
  overviewInfo.value = res.data as CustomerOverviewRespDTO
  data.userData = res.data
  /** 有待付款订单，显示弹窗提醒用户去支付 */
  if (res.data?.customerShop?.waitPayOrderCount) {
    obligationVisible.value = true
  }
})

const gotoLine = () => window.open('https://lin.ee/9noQAY4')
const closeModal = async () => {
  await setLineValue('1')
  const val = await getLineValue()
  showLine.value = val !== '1'
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BillNotify),
    _createVNode(CommonTip, { name: "stopPurchase,oemStatus" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(UserInfo, {
          userData: _unref(data).userData
        }, null, 8, ["userData"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(UserWallet, { overviewInfo: overviewInfo.value }, null, 8, ["overviewInfo"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(UserAbnormal, { workbenchOrderInfo: workbenchOrderInfo.value }, null, 8, ["workbenchOrderInfo"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(UserOrder, { workbenchOrderInfo: workbenchOrderInfo.value }, null, 8, ["workbenchOrderInfo"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(UserGoods, {
          overviewInfo: overviewInfo.value?.customerShop ?? {},
          workbenchOrderInfo: workbenchOrderInfo.value
        }, null, 8, ["overviewInfo", "workbenchOrderInfo"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(CommonFunctions)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(ActivitySection)
      ])
    ]),
    (!_unref(isSub))
      ? (_openBlock(), _createBlock(UserStores, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(FavoriteProducts),
    (!_unref(isD2C)())
      ? (_openBlock(), _createBlock(Guide, {
          key: 1,
          name: "b2b-usercenter"
        }))
      : _createCommentVNode("", true),
    (_unref(isD2C)())
      ? (_openBlock(), _createBlock(Guide, {
          key: 2,
          name: "d2c-usercenter"
        }))
      : _createCommentVNode("", true),
    _createVNode(ObligationModal, {
      zIndex: Z_INDEX_LIST.ObligationModal,
      visible: obligationVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((obligationVisible).value = $event)),
      userData: _unref(data).userData,
      title: _unref(t)('待付款提醒')
    }, null, 8, ["zIndex", "visible", "userData", "title"]),
    (_unref(isJA)())
      ? (_openBlock(), _createBlock(AdditionStockWarning, {
          key: 3,
          zIndex: Z_INDEX_LIST.AdditionStockWarning
        }, null, 8, ["zIndex"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createElementVNode("span", {
        class: "close",
        onClick: closeModal
      }, _hoisted_14),
      _createElementVNode("img", {
        onClick: gotoLine,
        src: "https://static-jp.theckb.com/static-asset/client/line.png",
        alt: "line",
        width: "320",
        height: "90"
      })
    ], 512), [
      [_vShow, showLine.value && _unref(isJA)()]
    ]),
    _createVNode(PackageRetentionDialog)
  ]))
}
}

})